var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#2C6ECB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 8.25H19.7675C19.51 7.5225 18.815 7 18 7C17.185 7 16.49 7.5225 16.2313 8.25H14.875C14.53 8.25 14.25 8.53 14.25 8.875V11.375C14.25 11.72 14.53 12 14.875 12H21.125C21.47 12 21.75 11.72 21.75 11.375V8.875C21.75 8.53 21.47 8.25 21.125 8.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 9.5H23V11.375C23 12.4088 22.1587 13.25 21.125 13.25H14.875C13.8412 13.25 13 12.4088 13 11.375V9.5H11.75C11.0612 9.5 10.5 10.0612 10.5 10.75V25.75C10.5 26.4513 11.0488 27 11.75 27H24.25C24.9513 27 25.5 26.4513 25.5 25.75V10.75C25.5 10.0488 24.9513 9.5 24.25 9.5ZM17.8175 20.5675L15.3175 23.0675C15.195 23.1888 15.035 23.25 14.875 23.25C14.715 23.25 14.555 23.1888 14.4325 23.0675L13.1825 21.8175C12.9387 21.5738 12.9387 21.1775 13.1825 20.9338C13.4262 20.69 13.8225 20.69 14.0663 20.9338L14.875 21.7413L16.9325 19.6838C17.1762 19.44 17.5725 19.44 17.8163 19.6838C18.06 19.9275 18.0613 20.3225 17.8175 20.5675ZM17.8175 15.5675L15.3175 18.0675C15.195 18.1888 15.035 18.25 14.875 18.25C14.715 18.25 14.555 18.1888 14.4325 18.0675L13.1825 16.8175C12.9387 16.5738 12.9387 16.1775 13.1825 15.9337C13.4262 15.69 13.8225 15.69 14.0663 15.9337L14.875 16.7413L16.9325 14.6837C17.1762 14.44 17.5725 14.44 17.8163 14.6837C18.06 14.9275 18.0613 15.3225 17.8175 15.5675ZM22.375 22H19.875C19.53 22 19.25 21.72 19.25 21.375C19.25 21.03 19.53 20.75 19.875 20.75H22.375C22.72 20.75 23 21.03 23 21.375C23 21.72 22.72 22 22.375 22ZM22.375 17H19.875C19.53 17 19.25 16.72 19.25 16.375C19.25 16.03 19.53 15.75 19.875 15.75H22.375C22.72 15.75 23 16.03 23 16.375C23 16.72 22.72 17 22.375 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.2c0d93a212baddd785ee92c71c38af89.svg";
export { ForwardRef as ReactComponent };